import React from 'react';
import Link from 'next/link';
import { Route } from '../../../enums';

export const CopyrightBarOrganism = () => {
  const currentDate = new Date();

  return (
    <section
      id="copyright-bar-organism"
      className="block w-full bg-waldo-azure px-5 py-5 box-border l:px-10 font-light"
    >
      <div className="block lg:flex justify-center items-center max-w-screen-lg  mx-auto">
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <p
            id="copyright-bar-text"
            className="text-white pb-1 lg:pb-0 text-sm lg:text-base"
          >
            &copy; WALDO {currentDate.getFullYear()} All rights reserved
          </p>
        </div>
        <div className="w-full lg:w-1/2 text-center lg:text-right">
          <p id="copyright-bar-links" className="text-white text-sm mt-2">
            <Link href={Route.PRIVACY_POLICY}>
              <a className="text-white text-sm lg:text-base" target="_blank">
                Privacy Policy
              </a>
            </Link>
            &nbsp; | &nbsp;
            <Link href={Route.COOKIE_POLICY}>
              <a
                className="text-white text-sm text-sm lg:text-base"
                target="_blank"
              >
                Cookie Policy
              </a>
            </Link>
            &nbsp; | &nbsp;
            <Link href={Route.TERMS_SERVICE}>
              <a
                className="text-white text-sm text-sm lg:text-base"
                target="_blank"
              >
                Terms of Service
              </a>
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};
